module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc_h"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Acknowledgments#sec1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Note#sec2"
    }
  }, [_vm._v("Note on Translations and Citations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ct1",
    attrs: {
      "id": "rsec3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#sec3"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1",
    attrs: {
      "id": "rsec4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#sec4"
    }
  }, [_vm._v("I. The Nature of Platonic Writing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1",
    attrs: {
      "id": "rsec5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#sec5"
    }
  }, [_vm._v("II. The Method of This Work")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1",
    attrs: {
      "id": "rsec6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#sec6"
    }
  }, [_vm._v("III. The Argument")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_pt",
    attrs: {
      "id": "rsec7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Part01#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Politics, Money, and Persuasion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ct",
    attrs: {
      "id": "rsec8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter01#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Problem of Abstraction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1",
    attrs: {
      "id": "rsec9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter01#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. The "), _c('i', [_vm._v("Polis")]), _vm._v(" and the Problem of the Guardians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1",
    attrs: {
      "id": "rsec10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter01#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Expertise and Writing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1",
    attrs: {
      "id": "rsec11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter01#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Money")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1",
    attrs: {
      "id": "rsec12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter01#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. "), _c('i', [_vm._v("Technē")]), _vm._v(", Money, and the Commercial "), _c('i', [_vm._v("Polis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ctt",
    attrs: {
      "id": "rsec13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter02#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Currencies of Power")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1",
    attrs: {
      "id": "rsec14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter02#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. Timocracy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1",
    attrs: {
      "id": "rsec15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter02#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Oligarchy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1",
    attrs: {
      "id": "rsec16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter02#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Democracy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_pt",
    attrs: {
      "id": "rsec17"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Part02#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. The Vicissitudes of Opinion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ct",
    attrs: {
      "id": "rsec18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter03#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "space"
  }, [_vm._v("True Opinion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1",
    attrs: {
      "id": "rsec19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter03#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. Socrates and the New Intellectuals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1",
    attrs: {
      "id": "rsec20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter03#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Knowledge and the “Divided Line”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1",
    attrs: {
      "id": "rsec21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter03#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Sophistry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ctt",
    attrs: {
      "id": "rsec22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter04#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Persuasion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1",
    attrs: {
      "id": "rsec23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter04#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. Persuasion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1",
    attrs: {
      "id": "rsec24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter04#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Virtue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1",
    attrs: {
      "id": "rsec25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter04#sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Corruption")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm",
    attrs: {
      "id": "rsec26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Conclusion#sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Bibliography#sec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Index_of_Subjects#sec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Subjects")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Index_of_Passages#sec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Passages")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2f62c52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 75
// module chunks = 0